module.exports = __webpack_public_path__ + "img/neijiang.1a050077.jpg";